import Vue from 'vue';

import {
  FEATURES_SHOW_ON_MAP,
  FEATURES_FETCH,
  FEATURES_GEOMETRY_ANALYSIS,
  FEATURES_PROXIMITY_ANALYSIS,
  FEATURES_NEAREST_ANALYSIS,
  FEATURES_SELECTED_MAP_ITEM,
  FEATURES_GET_IMPORTED_COUNT,
  MAP_SELECTION_APPLY,
  MAP_SELECTION_CLEAR
} from './actions.type';

import {
  VIEW_CENTER_SET,
  // MAP_SCALE_SET,
  FEATURES_GEOMETRIES_SET,
  FEATURES_SET,
  FEATURE_ADD,
  FEATURE_DELETE,
  FEATURE_EDIT,
  MULTIPLE_FEATURES_EDIT,
  FEATURES_COLUMNS_SET,
  FEATURES_TABLE_META_SET,
  FEATURES_DICTIONARIES_SET,
  FEATURES_PREPEND_FROM_SELECTION,
  FEATURES_COUNT_SET,
  FEATURES_LAYER_SET,
  FEATURES_TABLE_TOGGLE,
  FEATURES_SELECTED_TOGGLE,
  WINDOW_API_ERROR_SHOW,
  SPATIAL_ANALYSIS_HIDE_MODAL,
  FEATURES_DELETED_MAP_ITEM,
  FEATURES_TILE_LAYERS_FEATURES_SET,
  FEATURES_SELECT_ALL_SET,
  FEATURES_INDETERMINATE_SET,
  FEATURES_SHOW_DESELECT,
  FEATURES_TABLE_PAGE_NUMBER,
  FEATURES_TABLE_IS_LOADING,
  FEATURES_INVERTED_SET,
  FEATURES_IMPORTED_COUNT_SET,
  RESIZABLE_PANEL_FORCE_EXPANDED_SET,
  FEATURES_OFFSET_SET
} from './mutations.type';

import { Api as ApiWarstwy } from '../api/api-warstwy';
import { Api as ApiVectorLayers } from '../api/api-warstwy-wektorowe';
import { Api as ApiEditSession } from '../api/api-sesje-edycyjne';
import { Api as ApiDataFeed } from '../api/api-zasilenia-masowe';
import { transform } from 'ol/proj';
import moment from 'moment';

const initialState = {
  features: [],
  featuresGeometries: [],
  featuresColumns: [],
  tableMeta: [],
  dictionaries: [],
  featuresCount: 0,
  featuresImportedCount: 0,
  featuresLayer: undefined,
  featuresLoading: false,
  pageNumber: 1,
  showSelected: false,
  featuresTableActive: false,
  selectedItemOffset: 0,
  manuallyAddedFeatures: [],
  filterOrSortActive: false,
  selectedAll: false,
  indeterminate: false,
  isLoading: false,
  filterActive: false,
  inverted: false,
  isMore: false,
  isResponseObjectsLessThanPageSize: false,
  isRequestRepeatedForBiggerPageSize: false,
  previousIterationFeaturesSize: 0,
  isResponseEmpty: false,
  analysisRequestBody: null,
  forceResizablePanelExpand: false,
  removedFeatures: new Set(),
  tileLayersFeatures: {}
};

const layerApi = new ApiWarstwy();
const vectorLayersApi = new ApiVectorLayers();
const editSessionApi = new ApiEditSession();
const dataFeedApi = new ApiDataFeed();

let fetchFeaturesControl = null;
export const state = Object.assign({}, initialState);

export const actions = {
  [FEATURES_SHOW_ON_MAP]({ commit, getters }, data) {
    const center = transform(
      [data.x, data.y],
      'EPSG:2180',
      getters.coordinateSystem
    );
    commit(VIEW_CENTER_SET, center);
    // commit(MAP_SCALE_SET, data.skala);
  },
  [FEATURES_FETCH](
    context,
    {
      _this,
      filterString,
      filter,
      sortBy,
      sortDesc,
      pageNumber,
      pageSize,
      append,
      filterChange,
      selectedFeatures
    }
  ) {
    {
    }
    // if (
    //   !context.getters.featuresLayer ||
    //   !context.getters.featuresTableActive
    // ) {
    //   return;
    // }

    // if (selectedFeatures) {
    //   context.dispatch(MAP_SELECTION_CLEAR);
    // }

    // let control = Date.now().toString();
    // fetchFeaturesControl = control;

    // context.state.featuresLoading = true;
    // context.state.pageNumber = pageNumber || 1;

    // if (context.state.pageNumber == 1) {
    //   context.state.isLoading = true;
    // }

    // let filterActive = Boolean(
    //   (filter && typeof filter === 'string') || filterString
    // );
    // let filterOrSortActive = Boolean(filterActive || sortBy);
    // filterChange = filterChange || context.state.filterActive !== filterActive;

    // context.commit('setFilterOrSortActive', filterOrSortActive);
    // context.commit('setFilterActive', filterActive);

    // let request = null;
    // if (context.rootGetters.editSession) {
    //   // request = editSessionApi.getSesjeEdycyjneByIdObiekty({
    //   //   id: context.rootGetters.editSession,
    //   //   page_number: pageNumber || 1,
    //   //   items_per_page: pageSize || 1000,
    //   //   filter_str: filterString,
    //   //   filter: filter,
    //   //   order_by: sortBy,
    //   //   desc: sortDesc,
    //   //   control: control,
    //   //   // jesli import to pokaz tylko błędy
    //   //   tylko_bledy:
    //   //     context.getters.dataFeedId != null &&
    //   //     context.getters.dataFeedType != null
    //   //       ? true
    //   //       : false
    //   // });

    //   context.commit('setAnalysisRequestBody', null);
    // } else if (
    //   (filterString || filter || sortBy || sortDesc) &&
    //   state.analysisRequestBody
    // ) {
    //   const requestBody = { ...state.analysisRequestBody };
    //   (requestBody.page_number = pageNumber || 1),
    //     (requestBody.items_per_page = pageSize || 1000),
    //     (requestBody.filter_str = filterString);
    //   requestBody.filter = filter;
    //   requestBody.order_by = sortBy;
    //   requestBody.desc = sortDesc;
    //   requestBody.control = control;
    //   request = vectorLayersApi.postWarstwyWektoroweByIdObiektyAnaliza({
    //     ...requestBody,
    //     wso2_id: this.contextEmail ? this.contextEmail : null,
    //     orgid: this.contextOrganizationId ? this.contextOrganizationId : null
    //   });
    // } else {
    //   state.manuallyAddedFeatures = [];
    //   request = layerApi.getWarstwyWektoroweByIdObiekty({
    //     wso2_id: _this.contextEmail,
    //     orgid: _this.contextOrganizationId,
    //     id: context.getters.featuresLayer.id,
    //     page_number: pageNumber || 1,
    //     items_per_page: pageSize || 1000,
    //     filter_str: filterString,
    //     filter: filter,
    //     order_by: sortBy,
    //     desc: sortDesc,
    //     control: control,
    //     date: context.getters.featuresLayer.pointInThePast
    //   });
    //   context.state.featuresLoading = false;
    //   context.commit('setAnalysisRequestBody', null);
    // }

    // request
    //   .then(response => {
    //     if (response.body.control !== fetchFeaturesControl) {
    //       return;
    //     }

    //     let loadedFromMap = context.getters.features.filter(
    //       x => x.loadedFromMap
    //     );
    //     let loadedFromMapIds = new Set(loadedFromMap.map(x => x.id));

    //     let features = [];

    //     for (var feature of response.body.features) {
    //       if (
    //         state.manuallyAddedFeatures.indexOf(feature.id) == -1 &&
    //         (!append || !state.features.find(x => x.id == feature.id))
    //       ) {
    //         features.push(feature);
    //       }

    //       if (loadedFromMapIds.has(feature.id)) {
    //         loadedFromMapIds.delete(feature.id);
    //       }
    //     }

    //     if (context.getters.isRequestRepeatedForBiggerPageSize) {
    //       pageSize = pageSize / 2;
    //     }

    //     let responseFeaturesSize = features.length;
    //     let actuallyFeaturesSize = context.getters.features.length;

    //     // poprawka zwiazana z issue #39905
    //     context.commit(FEATURES_COUNT_SET, response.body.suma);

    //     if (
    //       responseFeaturesSize >
    //         context.getters.previousIterationFeaturesSize &&
    //       context.getters.isResponseObjectsLessThanPageSize
    //     ) {
    //       let newFeatures = context.getters.features
    //         .splice(
    //           0,
    //           actuallyFeaturesSize -
    //             context.getters.previousIterationFeaturesSize
    //         )
    //         .concat(features.splice(0, pageSize));
    //       features = newFeatures;
    //     }

    //     if (append) {
    //       features = context.getters.features
    //         .filter(x => !x.loadedFromMap || loadedFromMapIds.has(x.id))
    //         .concat(features);
    //     } else {
    //       let toPrepend = [];

    //       for (var feature of loadedFromMap) {
    //         if (
    //           context.rootGetters.selectedMapFeatures.has(feature.id) &&
    //           loadedFromMapIds.has(feature.id)
    //         ) {
    //           toPrepend.push(feature);
    //         }
    //       }
    //       features = (toPrepend || []).concat(features);
    //     }

    //     context.commit(
    //       'setIsResponseObjectsLessThanPageSize',
    //       responseFeaturesSize < pageSize && responseFeaturesSize != 0
    //         ? true
    //         : false
    //     );

    //     context.commit('setIsMore', response.body.suma > features.length);

    //     context.commit(
    //       'setPreviousIterationFeaturesSize',
    //       responseFeaturesSize >= pageSize ? 0 : responseFeaturesSize
    //     );

    //     context.commit('setIsRequestRepeatedForBiggerPageSize', false);

    //     context.commit('setIsResponseEmpty', responseFeaturesSize == 0);

    //     context.commit(FEATURES_SET, features);

    //     if (selectedFeatures) {
    //       context.dispatch(MAP_SELECTION_APPLY, {
    //         selectedFeatureObjs: selectedFeatures
    //       });
    //     }

    //     context.state.featuresLoading = false;
    //   })
    //   .catch(error => context.commit(WINDOW_API_ERROR_SHOW, error))
    //   .finally(x => {
    //     if (filterChange) {
    //       //context.dispatch(MAP_SELECTION_APPLY);
    //     }
    //   });
  },
  async [FEATURES_GEOMETRY_ANALYSIS](context, data) {
    try {
      if (context.rootGetters.spatialAnalysisModalVisible) {
        const analysisRequestBody = {
          id: context.getters.featuresLayer.id,
          body: {
            analiza_filter: {
              features_geojson: data.features_geojson,
              typ_analizy: data.typ_analizy,
              typ_wejsciowych: data.typ_wejsciowych,
              warstwa_id: data.warstwa_id,
              feature_ids_filter: data.feature_ids_filter
            }
          }
        };

        const analysisResponse = await vectorLayersApi.postWarstwyWektoroweByIdObiektyAnaliza(
          {
            ...analysisRequestBody,
            wso2_id: this.contextEmail ? this.contextEmail : null,
            orgid: this.contextOrganizationId
              ? this.contextOrganizationId
              : null
          }
        );
        context.commit('setAnalysisRequestBody', analysisRequestBody);
        context.commit(FEATURES_COUNT_SET, analysisResponse.body.suma);
        context.commit('setIsMore', false);
        context.commit(
          FEATURES_SET,
          analysisResponse.body.features.map(f => ({ ...f, selected: false }))
        );
        context.commit(SPATIAL_ANALYSIS_HIDE_MODAL);
        context.dispatch('clearTableState');

        if (!context.getters.featuresTableActive) {
          context.commit(FEATURES_TABLE_TOGGLE);
        }
      }
    } catch (e) {
      if (context.rootGetters.spatialAnalysisModalVisible) {
        context.commit(WINDOW_API_ERROR_SHOW, e);
      }
    }
  },
  async [FEATURES_PROXIMITY_ANALYSIS](context, data) {
    if (!context.getters.featuresLayer) {
      return;
    }

    try {
      if (context.rootGetters.spatialAnalysisModalVisible) {
        const analysisRequestBody = {
          id: data.referenceLayerId,
          body: {
            analiza_filter: {
              features_geojson: data.geometry,
              typ_analizy: data.analysisType,
              typ_wejsciowych: data.sourceLayerType,
              warstwa_id: data.sourceLayerId,
              max_odleglosc: data.maxDistance
            }
          }
        };

        const analysisResponse = await vectorLayersApi.postWarstwyWektoroweByIdObiektyAnaliza(
          {
            ...analysisRequestBody,
            wso2_id: this.contextEmail ? this.contextEmail : null,
            orgid: this.contextOrganizationId
              ? this.contextOrganizationId
              : null
          }
        );
        context.commit('setAnalysisRequestBody', analysisRequestBody);
        context.commit(FEATURES_COUNT_SET, analysisResponse.body.suma);
        context.commit('setIsMore', false);
        context.commit(
          FEATURES_SET,
          analysisResponse.body.features.map(f => ({ ...f, selected: false }))
        );
        context.commit(SPATIAL_ANALYSIS_HIDE_MODAL);
        context.dispatch('clearTableState');

        if (!context.getters.featuresTableActive) {
          context.commit(FEATURES_TABLE_TOGGLE);
        }
      }
    } catch (e) {
      if (context.rootGetters.spatialAnalysisModalVisible) {
        context.commit(WINDOW_API_ERROR_SHOW, e);
      }
    }
  },
  async [FEATURES_NEAREST_ANALYSIS](context, data) {
    if (!context.getters.featuresLayer) {
      return;
    }

    try {
      if (context.rootGetters.spatialAnalysisModalVisible) {
        const analysisRequestBody = {
          id: data.referenceLayerId,
          body: {
            analiza_filter: {
              features_geojson: data.geometry,
              typ_analizy: data.analysisType,
              typ_wejsciowych: data.sourceLayerType,
              warstwa_id: data.sourceLayerId,
              max_ilosc: data.maxQuantity
            }
          }
        };

        const analysisResponse = await vectorLayersApi.postWarstwyWektoroweByIdObiektyAnaliza(
          {
            ...analysisRequestBody,
            wso2_id: this.contextEmail ? this.contextEmail : null,
            orgid: this.contextOrganizationId
              ? this.contextOrganizationId
              : null
          }
        );
        context.commit('setAnalysisRequestBody', analysisRequestBody);
        context.commit(FEATURES_COUNT_SET, analysisResponse.body.suma);
        context.commit('setIsMore', false);
        context.commit(
          FEATURES_SET,
          analysisResponse.body.features.map(f => ({ ...f, selected: false }))
        );
        context.commit(SPATIAL_ANALYSIS_HIDE_MODAL);
        context.dispatch('clearTableState');

        if (!context.getters.featuresTableActive) {
          context.commit(FEATURES_TABLE_TOGGLE);
        }
      }
    } catch (e) {
      if (context.rootGetters.spatialAnalysisModalVisible) {
        context.commit(WINDOW_API_ERROR_SHOW, e);
      }
    }
  },
  async [FEATURES_SELECTED_MAP_ITEM]({ rootGetters, state }, payload) {
    if (!state.featuresTableActive) {
      return;
    }
    if (payload.itemId) {
      const feature = state.features.find(f => f.id === payload.itemId);

      if (feature) {
        state.selectedItemOffset = state.features.indexOf(feature);
      } else if (rootGetters.editSession) {
        const featureDataRequest = await editSessionApi.getSesjeEdycyjneByIdObiektyByFeatureId(
          { id: rootGetters.editSession, feature_id: payload.itemId }
        );
        const featureData = featureDataRequest.body;
        delete featureData.control;
        state.features.unshift(featureData);
        state.manuallyAddedFeatures.push(featureData.id);
        state.selectedItemOffset = 0;
      }
    }
  },
  async [FEATURES_GET_IMPORTED_COUNT](context) {
    const dataFeedId = context.rootGetters.dataFeedId;
    const dataFeedType = context.rootGetters.dataFeedType;
    const editSession = context.rootGetters.editSession;

    if (editSession) {
      const response = await editSessionApi.getSesjeEdycyjneByIdLiczbaObiektow({
        id: editSession
      });

      if (response && response.body && response.body.suma) {
        context.commit(FEATURES_IMPORTED_COUNT_SET, response.body.suma);
      }
    } else if (dataFeedId != null && dataFeedType != null) {
      const response = await dataFeedApi.getZasilenieMasoweByIdRaport({
        id: dataFeedId
      });
      if (response && response.body) {
        const result = response.body.raport.filter(r => {
          return r.dzialanie && r.dzialanie === 'Import do bazy buforowej';
        });

        if (result.length > 0) {
          const rowsCount = result[0].liczba_rekordow;
          context.commit(FEATURES_IMPORTED_COUNT_SET, rowsCount);
        }
      }
    }
  },
  clearTableState({ dispatch }) {
    dispatch(MAP_SELECTION_APPLY);
  }
};

export const mutations = {
  [FEATURES_GEOMETRIES_SET](state, featuresGeometries) {
    state.featuresGeometries = featuresGeometries;
  },
  [FEATURES_SET](state, features) {
    state.features = features;
  },
  [FEATURE_ADD](state, feature) {
    state.features = [feature, ...state.features];
  },
  [FEATURE_DELETE](state, featureId) {
    state.features = state.features.filter(feature => {
      return feature.id != featureId;
    });
  },
  [FEATURE_EDIT](state, updatedFeature) {
    state.features = state.features.map(feature => {
      if (feature.id === updatedFeature.id) {
        return updatedFeature;
      } else {
        return feature;
      }
    });
  },
  [MULTIPLE_FEATURES_EDIT](state, updatedFeatures) {
    state.features = state.features.map(feature => {
      const updatedFeature = updatedFeatures.find(
        ({ id }) => id === feature.id
      );
      return updatedFeature || feature;
    });
  },
  [FEATURES_COLUMNS_SET](state, featuresColumns) {
    state.featuresColumns = featuresColumns;
  },
  [FEATURES_TABLE_META_SET](state, tableMeta) {
    state.tableMeta = tableMeta;
  },
  [FEATURES_DICTIONARIES_SET](state, dictionaries) {
    state.dictionaries = dictionaries;
  },
  [FEATURES_PREPEND_FROM_SELECTION](state, features) {
    let toPrepend = [];
    (features || []).forEach(x => {
      if (!state.features.find(y => y.id === x.id)) {
        x.loadedFromMap = true;
        toPrepend.push(x);
      }
    });
    state.features = [...toPrepend, ...state.features];
    state.selectedItemOffset = 0;
  },
  [FEATURES_COUNT_SET](state, featuresCount) {
    state.featuresCount = featuresCount;
  },
  [FEATURES_IMPORTED_COUNT_SET](state, importedFeaturesCount) {
    state.featuresImportedCount = importedFeaturesCount;
  },
  [FEATURES_LAYER_SET](state, layer) {
    state.featuresLayer = layer;
  },
  [FEATURES_TABLE_TOGGLE](state, show) {
    state.featuresTableActive = show || !state.featuresTableActive;
  },
  [FEATURES_SELECTED_TOGGLE](state) {
    state.showSelected = !state.showSelected;
  },
  [FEATURES_SHOW_DESELECT](state) {
    state.showSelected = false;
  },
  [FEATURES_DELETED_MAP_ITEM](state, itemId) {
    if (!state.featuresTableActive) {
      return;
    }

    state.removedFeatures.add(itemId);

    const featureIndex = state.features.findIndex(f => f.id === itemId);

    if (featureIndex > -1) {
      state.features.splice(featureIndex, 1);
    }
  },
  [FEATURES_TILE_LAYERS_FEATURES_SET](state, tileLayersFeatures) {
    state.tileLayersFeatures = tileLayersFeatures;
  },
  setFilterOrSortActive(state, value) {
    state.filterOrSortActive = value;
  },
  [FEATURES_SELECT_ALL_SET](state, value) {
    state.selectedAll = value;
  },
  [FEATURES_INDETERMINATE_SET](state, value) {
    state.indeterminate = value;
  },
  [FEATURES_TABLE_PAGE_NUMBER](state, value) {
    state.pageNumber = value;
  },
  [FEATURES_TABLE_IS_LOADING](state, value) {
    state.isLoading = value;
  },
  setFilterActive(state, value) {
    state.filterActive = value;
  },
  [FEATURES_INVERTED_SET](state, value) {
    state.inverted = value;
  },
  setIsMore(state, value) {
    state.isMore = value;
  },
  setIsResponseObjectsLessThanPageSize(state, value) {
    state.isResponseObjectsLessThanPageSize = value;
  },
  setIsRequestRepeatedForBiggerPageSize(state, value) {
    state.isRequestRepeatedForBiggerPageSize = value;
  },
  setPreviousIterationFeaturesSize(state, value) {
    state.previousIterationFeaturesSize = value;
  },
  setIsResponseEmpty(state, value) {
    state.isResponseEmpty = value;
  },
  setAnalysisRequestBody(state, request) {
    state.analysisRequestBody = request;
  },
  [RESIZABLE_PANEL_FORCE_EXPANDED_SET](state, value) {
    state.forceResizablePanelExpand = value;
  },
  [FEATURES_OFFSET_SET](state, feature) {
    if (feature) {
      state.selectedItemOffset = state.features.indexOf(feature);
    }
  }
};

const getters = {
  featuresGeometries(state) {
    return state.featuresGeometries;
  },
  activeLayerFeatures(state, _getters, _rootState, rootGetters) {
    const { activeLayer } = rootGetters;
    if (!activeLayer) return [];

    return state.features.filter(({ layer }) => layer === activeLayer.id);
  },
  features(state) {
    return state.features;
  },
  featuresColumns(state) {
    return state.featuresColumns;
  },
  tableMeta() {
    return state.tableMeta;
  },
  dictionaries() {
    return state.dictionaries;
  },
  selectedFeatures(state) {
    return state.features.filter(feature => feature.selected);
  },
  featuresCount(state) {
    return state.featuresCount;
  },
  featuresImportedCount(state) {
    return state.featuresImportedCount;
  },
  featuresLayer(state) {
    return state.featuresLayer;
  },
  featuresTableActive(state) {
    return state.featuresTableActive;
  },
  pageNumber(state) {
    return state.pageNumber;
  },
  isLoading(state) {
    return state.isLoading;
  },
  showSelected(state) {
    return state.showSelected;
  },
  previousIterationFeaturesSize(state) {
    return state.previousIterationFeaturesSize;
  },
  shownFeatures(state, getters) {
    // hardcodowane klucze dla dat (Issue #24812)
    if (getters.features.length > 0) {
      getters.features.forEach(feature => {
        Object.keys(feature.properties).forEach(x => {
          if (x == 'z_2_ii_6' || x == 'z_2_iii_6' || x == 'z_2_iv_6') {
            if (feature.properties[x] != '' && feature.properties[x] != null) {
              if (!isNaN(feature.properties[x])) {
                feature.properties[x] = moment
                  .unix(feature.properties[x])
                  .format('DD-MM-YYYY HH:mm');
              }
            }
          }
        });
      });
    }

    if (state.showSelected) {
      return getters.features.filter(x =>
        getters.selectedMapFeatures.has(x.id)
      );
    }
    return getters.features;
  },
  featuresLoading(state) {
    return state.featuresLoading;
  },
  selectedItemOffset: state => state.selectedItemOffset,
  currentCount(state) {
    return state.features.length;
  },
  filterOrSortActive() {
    return state.filterOrSortActive;
  },
  selectedAll() {
    return state.selectedAll;
  },
  indeterminate() {
    return state.indeterminate;
  },
  filterActive() {
    return state.filterActive;
  },
  inverted() {
    return state.inverted;
  },
  isMore(state) {
    return state.isMore;
  },
  isRequestRepeatedForBiggerPageSize(state) {
    return state.isRequestRepeatedForBiggerPageSize;
  },
  isResponseObjectsLessThanPageSize(state) {
    return state.isResponseObjectsLessThanPageSize;
  },
  isResponseEmpty(state) {
    return state.isResponseEmpty;
  },
  forceResizablePanelExpand(state) {
    return state.forceResizablePanelExpand;
  },
  removedFeatures(state) {
    return state.removedFeatures;
  },
  tileLayersFeatures(state) {
    return state.tileLayersFeatures;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
